import React from 'react';
/**
 * Require: name, description, handleChange, value
 * Optional: className, type, required, valid, error
 */
export default (props) => {
  let valid, required, type, className, autocomplete, value;
  valid = props.error===undefined;
  required = props.required===undefined ? false : props.required;
  type = props.type===undefined ? "text" : props.type;
  className = props.className===undefined ? "" : props.className;
  autocomplete = props.autoComplete===undefined ? "on" : props.autoComplete;
  value = props.value===undefined ? "" : props.value;
  return (
    <div className="form-group">
      <label htmlFor={`i_${props.name}`}>{props.description}</label>
      <input
        className={`form-control ${valid ? "" : "is-invalid"} ${className}`}
        type={type}
        value={value}
        onChange={props.handleChange}
        name={props.name}
        id={`i_${props.name}`}
        autoComplete={autocomplete}
        required={required} />

      {props.valid ? "" :
        <div className="invalid-feedback">
          {props.error}
        </div>}
    </div>
  );
};

//name, description, className="", type="text", required=false, valid=true)



// WEBPACK FOOTER //
// ./src/forms/PInput.js